<template>
    <div class="product">
        <el-tabs v-model="tabsKey" type="card" >
            <el-tab-pane label="商品" name="product">
                    <products />
            </el-tab-pane>
            <el-tab-pane label="系列別" name="class">
                <classSearch />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import products from './Product/products'
import classSearch from './Class/Search'
    export default {
        name: 'Product',
        data() {
            return {
                tabsKey: 'product'
            }
        },
        components: {
            products,
            classSearch
        }
    }
</script>

<style lang="scss">
    #tab-product {
            font-size: 22px !important;
            margin-left: 16px;
          
              font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
      
    }
    #tab-class {
             font-size: 22px !important;
            margin-left: 16px;
              font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
      
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
    }
</style>